// extracted by mini-css-extract-plugin
module.exports = {"form":"src-_components-___ChangePasswordForm-module__form___3uIiY"};